import { useFormContext } from 'react-hook-form';
import {
  IntegrationSettingsEntryRequiredStatus,
  IntegrationSettingsForm,
  IntegrationSettingsTypedInputProps,
} from 'modules/integrationSettings/types';
import { SwitchField } from 'components/form';

export const BooleanInput = ({ integrationSettingsEntry, dataKey }: IntegrationSettingsTypedInputProps) => {
  const { control } = useFormContext<IntegrationSettingsForm>();

  const required = integrationSettingsEntry.requiredStatus === IntegrationSettingsEntryRequiredStatus.Required;
  const name = `${integrationSettingsEntry.level}.${dataKey}.integrationSettingsValues.${integrationSettingsEntry.name}`;

  return (
    <SwitchField
      control={control}
      label={integrationSettingsEntry.displayName}
      // rules={{ required }}
      required={required}
      name={name as any}
    />
  );
};
